
import React from 'react';
import styles from './_quoter-error.module.scss';
import {Error} from "@progress/kendo-react-labels";
import {hasValue} from "@amsanalytics/react-shared-library";

export interface QuoterErrorProps {
  message: string | undefined;
}

export default function QuoterError (props:  QuoterErrorProps) {
  return (
    <div className={styles.quoterErrorContainer}>
      {hasValue(props.message) && <Error>{props.message}</Error>}
    </div>
  );
}
